<template>
  <div :class="[$style.topicItem, $style[getColorClassName(value, type)]]">
    <span :class="$style.topicName">{{ topic }}</span>
    <span :class="$style.topicValue">{{ formatValue(value, type) }}</span>
    <span v-if="showTaskCount" :class="$style.topicCount">
      ({{ taskCount }} tasks)
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  topic: string;
  value: number;
  type: "accuracy" | "overrun";
  taskCount?: number;
  showTaskCount?: boolean;
}

withDefaults(defineProps<Props>(), {
  showTaskCount: false,
});

function getColorClassName(
  value: number,
  type: "accuracy" | "overrun"
): string {
  if (type === "accuracy") {
    if (value <= 105) return "topicGreen";
    if (value <= 110) return "topicYellow";
    if (value <= 120) return "topicOrange";
    return "topicRed";
  } else {
    // overrun type
    if (value === 0) return "topicGreen";
    if (value > 0 && value <= 50) return "topicYellow";
    return "topicRed";
  }
}

function formatValue(value: number, type: "accuracy" | "overrun"): string {
  if (type === "accuracy") {
    return `${value.toFixed(1)}%`;
  } else {
    return `${value.toFixed(1)}% overrun`;
  }
}
</script>

<style module>
.topicItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  border-left: 3px solid rgba(255, 255, 255, 0.3);
  gap: 8px;
}

.topicGreen {
  background: rgba(0, 184, 148, 0.1) !important;
  border-left-color: #00b894 !important;
}

.topicYellow {
  background: rgba(253, 203, 110, 0.1) !important;
  border-left-color: #fdcb6e !important;
}

.topicOrange {
  background: rgba(225, 112, 85, 0.1) !important;
  border-left-color: #e17055 !important;
}

.topicRed {
  background: rgba(255, 107, 107, 0.1) !important;
  border-left-color: var(--task-design) !important;
}

.topicName {
  font-weight: 500;
  color: white;
  flex: 1;
}

.topicValue {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  white-space: nowrap;
}

.topicCount {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  white-space: nowrap;
}

.topicGreen .topicValue {
  color: #00b894 !important;
}

.topicYellow .topicValue {
  color: #fdcb6e !important;
}

.topicOrange .topicValue {
  color: #e17055 !important;
}

.topicRed .topicValue {
  color: var(--task-design) !important;
}

.topicInBetween {
  background: rgba(255, 193, 7, 0.1) !important;
  border-left-color: #ffc107 !important;
}

.topicInBetween .topicValue {
  color: #ffc107 !important;
}
</style>
